import API from "serviceshift-ui/api-client";

import "./interceptors";
import { getAPIURL } from "../lib/helpers";
import accessRole from "./modules/accessRole";
import accountingCategory from "./modules/accountingCategory";
import accountingClass from "./modules/accountingClass";
import adminPreferences from "./modules/adminPreferences";
import adminActions from "./modules/admins";
import appointmentActions from "./modules/appointment";
import assets from "./modules/assets";
import backgroundTasks from "./modules/backgroundTasks";
import batches from "./modules/batches";
import breadcrumbs from "./modules/breadcrumbs";
import calendarEvents from "./modules/calendarEvents";
import callActions from "./modules/calls";
import choices from "./modules/choices";
import companySettings from "./modules/companySettings";
import componentTypes from "./modules/componentTypes";
import coverageAreas from "./modules/coverageAreas";
import customizationActions from "./modules/customizations";
import dashboard from "./modules/dashboard";
import dataLoad from "./modules/dataLoad";
import department from "./modules/department";
import emailTemplates from "./modules/emailTemplates";
import equipment from "./modules/equipment";
import equipmentTypes from "./modules/equipmentTypes";
import importedDataWarning from "./modules/importedDataWarning";
import inventory from "./modules/inventory";
import invoice from "./modules/invoice";
import job from "./modules/job";
import jobPaymentSchedule from "./modules/jobPaymentSchedule";
import jobStatuses from "./modules/jobStatuses";
import jobStatusFinalWarning from "./modules/jobStatusFinalWarning";
import lenderSettings from "./modules/lenderSettings";
import loanPrograms from "./modules/loanPrograms";
import memberships from "./modules/memberships";
import parts from "./modules/parts.js";
import paymentMethods from "./modules/paymentMethods.js";
import pricebookCategories from "./modules/pricebookCategories";
import pricing from "./modules/pricing";
import progressBilling from "./modules/progressBilling";
import purchaseOrders from "./modules/purchaseOrders";
import quickbooks from "./modules/quickbooks";
import quoteBuilder from "./modules/quoteBuilder";
import reports from "./modules/reports";
import schedule from "./modules/schedule";
import scheduleBoard from "./modules/scheduleBoard";
import scheduler from "./modules/scheduler";
import serviceCategories from "./modules/serviceCategories";
import tags from "./modules/tags";
import tasks from "./modules/tasks";
import taxability from "./modules/taxability";
import tenant from "./modules/tenant";
import timesheets from "./modules/timesheets";
import todos from "./modules/todos";
import users from "./modules/users";
import vendors from "./modules/vendors";
import warranties from "./modules/warranties";
import warrantyTodos from "./modules/warrantyTodos";
import workCrews from "./modules/workCrews";
import workItems from "./modules/workItems";

// Set api-client base url
API.init({
  API_BASE_URL: getAPIURL()
});

export default {
  ...accessRole,
  ...accountingCategory,
  ...accountingClass,
  ...adminActions,
  ...adminPreferences,
  ...appointmentActions,
  ...batches,
  ...backgroundTasks,
  ...breadcrumbs,
  ...calendarEvents,
  ...callActions,
  ...choices,
  ...companySettings,
  ...componentTypes,
  ...coverageAreas,
  ...customizationActions,
  ...dashboard,
  ...dataLoad,
  ...department,
  ...emailTemplates,
  ...equipment,
  ...equipmentTypes,
  ...lenderSettings,
  ...loanPrograms,
  ...importedDataWarning,
  ...inventory,
  ...jobStatusFinalWarning,
  ...invoice,
  ...job,
  ...memberships,
  ...parts,
  ...paymentMethods,
  ...jobPaymentSchedule,
  ...assets,
  ...pricebookCategories,
  ...pricing,
  ...progressBilling,
  ...purchaseOrders,
  ...quoteBuilder,
  ...reports,
  ...schedule,
  ...scheduler,
  ...scheduleBoard,
  ...serviceCategories,
  ...tags,
  ...tasks,
  ...tenant,
  ...timesheets,
  ...todos,
  ...users,
  ...vendors,
  ...warranties,
  ...warrantyTodos,
  ...workCrews,
  ...workItems,
  ...taxability,
  ...quickbooks,
  ...jobStatuses,
  confirmChanges({ dispatch }, params = {}) {
    return dispatch("confirmDelete", params);
  },
  confirmDelete({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      commit("setupConfirm", { resolve, reject });
      commit("toggleConfirmChanges", { show: true, ...params });
    });
  }
};
